export default {"src":"/org/_next/static/media/clock-white.c60c0131.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};